import React, { useEffect, useState } from 'react';

import { Grid } from "@mui/material";

import GeneralService from '../../services/general';
import { CODES } from '../../utils/responseCodes';
import { simpleAlerts } from '../../utils/alerts';
import MainSelect from './General/MainSelect';

const GroupingUnit = ({
    infoCompany, setInfoCompany,
    infoClient, setInfoClient,
    infoUnit, setInfoUnit,

}) => {
    const [companies, setCompanies] = useState(null);
    const [clients, setClients] = useState(null);
    const [units, setUnits] = useState(null);

    useEffect(() => {
        getEmpresas();
    }, [])

    useEffect(() => {
        if (infoCompany)
            getClientesByEmpresa();
        setUnits(null);
        setInfoClient(null);
        setInfoUnit(null);
    }, [infoCompany])

    useEffect(() => {
        if (infoClient)
            getUnidadesByCliente();
        setInfoUnit(null);
    }, [infoClient])

    const getEmpresas = async () => {
        await GeneralService.getEmpresas()
            .then(result => {
                if (result.status === CODES.SUCCESS_200) {
                    result.data?.forEach(element => {
                        element.value = element.id_empresa
                        element.label = element.desEmpresa
                    })
                    setCompanies(result.data);
                } else {
                    simpleAlerts('No hay información de empresas', 'info');
                }
            })
            .catch(err => {
                console.log('getEmpresas', err)
            })

    }

    const getClientesByEmpresa = async () => {
        await GeneralService.getClientesByEmpresa(infoCompany?.value).then(result => {
            if (result.status === CODES.SUCCESS_200) {
                result.data?.forEach(element => {
                    element.value = element.id_cliente
                    element.label = element.desCliente
                })
                setClients(result.data);
            } else {
                simpleAlerts('No hay información de clientes', 'info');
            }
        })
            .catch(err => {
                console.log('getClientesByEmpresa', err)
            })
    }

    const getUnidadesByCliente = async () => {
        await GeneralService.getUnidadesByCliente(infoClient?.value)
            .then(result => {
                if (result.status === CODES.SUCCESS_200) {
                    result.data?.forEach(element => {
                        element.value = element.id_unidad
                        element.label = element.desUnidad
                    })
                    setUnits(result.data);
                } else {
                    simpleAlerts('No hay información de unidades', 'info');
                }
            })
            .catch(err => {
                console.log('getEmpresas', err)
            })
    }

    return (
        <Grid container p={1}>
            <Grid item xs={12} sm={6} md={4}>
                <MainSelect
                    title={'Empresa'}
                    options={companies}
                    placeholder={'Selecionar Empresa'}
                    value={Number(infoCompany?.value)}
                    onChange={(value, event) => setInfoCompany(companies?.find(element => element.value === Number(value)))}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MainSelect
                    title={'Cliente'}
                    options={clients}
                    placeholder={'Selecionar Cliente'}
                    value={Number(infoClient?.value)}
                    onChange={(value, event) => setInfoClient(clients?.find(element => element.value === Number(value)))}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MainSelect
                    title={'Unidad'}
                    options={units}
                    placeholder={'Selecionar Unidad'}
                    value={Number(infoUnit?.value)}
                    onChange={(value, event) => setInfoUnit(units?.find(element => element.value === Number(value)))}
                />
            </Grid>

        </Grid>
    );
};

export default GroupingUnit;